import { render, staticRenderFns } from "./idle.dialog.component.vue?vue&type=template&id=07a83e68&"
import script from "./idle.dialog.component.vue?vue&type=script&lang=js&"
export * from "./idle.dialog.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports